const handleIcons = (name) => {
    console.log(name);
    switch (name) {
        case "English":
            return "/subIcon/ic_png_english.png"
        case "Hindi":
            return "/subIcon/ic_png_hindi.png"
        case "Maths":
            return "/subIcon/ic_png_maths.png"
        case "Science":
            return "/subIcon/ic_png_science.png"
        case "Environmental Studies":
            return "/subIcon/ic_png_evs.png"
        case "Physics":
            return "/subIcon/ic_png_physics.png"
        case "Biology":
            return "/subIcon/ic_png_biology.png"
        case "Chemistry":
            return "/subIcon/ic_png_chemistry.png"
        case "Geography":
            return "/subIcon/ic_png_geography.png"
        case "History":
            return "/subIcon/ic_png_history.png"
        case "Social and Political Science":
            return "/subIcon/ic_png_social_science.png"
        case "Political Science":
            return "/subIcon/ic_png_political_science.png"
        case "Statistics":
            return "/subIcon/ic_png_statistics.png"
        case "Sanskrit":
            return "/subIcon/ic_png_sanskrit.png"
        case "Kannada":
            return "/subIcon/ic_png_kannada.png"
        default:
            return "/subIcon/ic_other_subject.png";
    }
}
module.exports = {
    handleIcons
}